import { createSelector } from '@ngrx/store';
import { AppStateInterface } from '../types';

export const selectHomeData = (state: AppStateInterface) => state.homeData;

export const isLaodingHomeDataSelector = createSelector(
  selectHomeData,
  (state) => state.isLoading,
);
export const successHomeDataSelector = createSelector(
  selectHomeData,
  (state) => state.homeData,
);
export const errorHomeDataSelector = createSelector(
  selectHomeData,
  (state) => state.error,
);
